// Dados da empresa em um lugar só: Contato, Rodapé e Produtos leem daqui.
export const empresa = {
  nome: 'Polisul',
  nomeCompleto: 'Polisul Alimentos',
  telefone: '(53) 3283-3500',
  whatsapp: '555332833500',             // só dígitos, com DDI, para wa.me
  email: 'polisulalimentos@polisulalimentos.com.br',
  local: 'Pelotas, Rio Grande do Sul',
  horario: 'Seg–Sex, 8h às 18h',
  anosDeMercado: 20,                     // vídeo institucional: "mais de 20 anos"
  marcas: ['Alteza', 'Uniforça', 'Imperato', 'Karajá', 'Cometa', 'Icapuí', 'Bom Mestre', 'Grão do Sul'],
};
